import {createAction} from 'redux-actions';
import * as Constants from './constants';

export const getListWarehouseAction = createAction(Constants.GET_LIST_WAREHOUSE.REQUEST, (filters) => (filters));
